module.exports = __webpack_public_path__ + "static/media/connect_wallet.6168242b.svg";